export class LoadingStateShowLoading {
  static readonly type = '[LoadingState] show loading';
}

export class LoadingStateHideLoading {
  static readonly type = '[LoadingState] hide loading';
}
